<template>
  <div class="wrapper">
    <!-- 返回按钮 -->
    <div class="back-btn-box" style="margin-bottom: 40px;">
      <button-a
        class="goBackBtn"
        color="#707070"
        bgcolor="transparent"
        @click.native="$router.go(-1)"
      >
        <i class="el-icon-back"></i> 返回列表
      </button-a>
    </div>
    
    <!-- 基本信息卡片 -->
    <div class="info-card">
      <div class="avatar">
        <span class="avatar-text">{{ (employeeName && employeeName.length > 0) ? employeeName.charAt(0) : '?' }}</span>
      </div>
      <div class="info-content">
        <div class="employee-name">{{ employeeName || '-' }}</div>
        <div class="info-row-second">
          <span class="info-detail">证件号码：{{ idCard || '-' }}</span>
          <span class="info-detail">薪资月份：{{ salaryDate || '-' }}</span>
          <span class="info-detail">薪资类型：{{ setType || '-' }}</span>
          <span class="info-detail">开户行：{{ openingBank || '-' }}</span>
        </div>
        <div class="info-row-third">
          <span class="info-detail">银行卡号：{{ employeCard || '-' }}</span>
        </div>
      </div>
    </div>

    <!-- 考勤概览 -->
    <div class="section-card attendance-card">
      <div class="section-header">
        <img class="section-icon" src="@/assets/icons/date.png" alt="考勤" />
        <h3 class="section-title">考勤概览</h3>
      </div>
      <div class="attendance-content">
        <div class="attendance-left">
          <div class="attendance-row">
            <span class="label">应出勤天数</span>
            <span class="value">{{ attendanceInfo.shouldAttend || 0 }}</span>
          </div>
          <div class="attendance-row">
            <span class="label">实出勤天数</span>
            <span class="value">{{ attendanceInfo.actualAttend || 0 }}</span>
          </div>
        </div>
        <div class="attendance-right">
          <span class="label">实发薪资</span>
          <span class="amount">￥{{ finalPayAmount[0] ? finalPayAmount[0].accountItemValue : "0.00" }}</span>
        </div>
      </div>
    </div>

    <!-- 应发薪资 -->
    <div class="section-card">
      <div class="section-header">
        <span class="section-icon blue">|</span>
        <h3 class="section-title">应发薪资</h3>
      </div>
      <div class="salary-grid">
        <div class="grid-item" v-for="item in payAmountGrid" :key="item.name">
          <p class="item-name">{{ item.name }}</p>
          <p class="item-value">{{ item.value }}</p>
        </div>
      </div>
    </div>

    <!-- 应扣薪资 -->
    <div class="section-card">
      <div class="section-header">
        <span class="section-icon red">|</span>
        <h3 class="section-title">应扣薪资</h3>
      </div>
      <div class="salary-grid">
        <div class="grid-item total" v-for="item in deductionGrid" :key="item.name">
          <p class="item-name">{{ item.name }}</p>
          <p class="item-value" :class="{ negative: item.negative }">{{ item.value }}</p>
        </div>
      </div>
    </div>

    <!-- 专项附加扣除 -->
    <div class="section-card" v-show="deductionGridItems.length > 0">
      <div class="section-header">
        <span class="section-icon orange">|</span>
        <h3 class="section-title">专项附加扣除(抵扣项)</h3>
      </div>
      <div class="salary-grid">
        <div class="grid-item" v-for="item in deductionGridItems" :key="item.name">
          <p class="item-name">{{ item.name }}</p>
          <p class="item-value">{{ item.value }}</p>
        </div>
      </div>
    </div>

    <!-- 税后减项和税后加项 -->
    <div class="bottom-section">
      <div class="section-card half-card">
        <div class="section-header">
          <span class="section-icon purple">|</span>
          <h3 class="section-title">税后减项</h3>
        </div>
        <div class="salary-grid half-grid">
          <div class="grid-item" v-for="item in afterTaxDeductionGrid" :key="item.name">
            <p class="item-name">{{ item.name }}</p>
            <p class="item-value">{{ item.value }}</p>
          </div>
        </div>
      </div>
      <div class="section-card half-card">
        <div class="section-header">
          <span class="section-icon green">|</span>
          <h3 class="section-title">税后加项</h3>
        </div>
        <div class="salary-grid half-grid">
          <div class="grid-item" v-for="item in afterTaxAddGrid" :key="item.name">
            <p class="item-name">{{ item.name }}</p>
            <p class="item-value">{{ item.value }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Get } from "@/js/http.js";
export default {
  components: {},
  props: {},
  data() {
    return {
      pkid: this.$route.params.pkid,
      setType: this.$route.params.setType,
      employeCard: "",
      employeeName: "",
      idCard: "",
      openingBank: "",
      salaryDate: "",
      status: "",
      items: [],
      attendanceInfo: {
        shouldAttend: 0,
        actualAttend: 0
      },
      finalPayAmount: [],
      totalPayAmountSum: 0.0,
      totalPayAmountSumExist: "",
      totalDeductionSum: 0.0,
      payAmountGrid: [],
      deductionGrid: [],
      deductionGridItems: [],
      afterTaxDeductionGrid: [],
      afterTaxAddGrid: []
    };
  },
  watch: {},
  computed: {},
  methods: {
    GetData() {
      this.totalPayAmountSum = 0.0;
      this.totalDeductionSum = 0.0;
      this.totalPayAmountSumExist = "";
      
      Get(`api/v1/employee-salaries/${this.pkid}`).then(res => {
        this.items = res.data.items;
        this.sort("positionIndex");
        this.employeeName = res.data.basicInfo.employeeName;
        this.idCard = res.data.basicInfo.idCard;
        this.salaryDate = res.data.basicInfo.salaryDate;
        this.setType = res.data.basicInfo.setType;
        this.openingBank = res.data.basicInfo.openingBank;
        this.employeCard = res.data.basicInfo.employeeCard;
        
        let totalPayAmountSumExist = this.items.find(item => item.itemName === "应发薪资");
        if(totalPayAmountSumExist) {
          this.totalPayAmountSumExist = totalPayAmountSumExist.accountItemValue;
          this.totalPayAmountSum = parseFloat(totalPayAmountSumExist.accountItemValue) || 0;
        }
        
        let totalDeductionSumExist = this.items.find(item => item.itemName === "应扣薪资");
        if(totalDeductionSumExist) {
          this.totalDeductionSum = parseFloat(totalDeductionSumExist.accountItemValue) || 0;
        }
        
        this.attendanceInfo.shouldAttend = this.items.find(item => item.itemName === "应出勤天数")?.accountItemValue || 0;
        this.attendanceInfo.actualAttend = this.items.find(item => item.itemName === "实出勤天数")?.accountItemValue || 0;
        
        this.finalPayAmount = this.items.filter(s => s.itemName == "实发薪资");
        
        this.buildGrids();
        
        this.totalPayAmountSum = parseFloat(this.totalPayAmountSum).toFixed(2);
        this.totalDeductionSum = parseFloat(this.totalDeductionSum).toFixed(2);
      });
    },
    buildGrids() {
      // 获取特定显示项的值
      const getDisplayValue = (name) => {
        const item = this.items.find(i => i.itemName === name);
        return item ? item.accountItemValue : "";
      };
      
      // 应发薪资：salaryType=税前加项，如果为null；需要显示名称，具体数值为空
      const preTaxAddItems = this.items.filter(item => item.salaryType === "税前加项");
      const preTaxAddGridItems = preTaxAddItems.map(item => ({
        name: item.itemName || "",
        value: item.accountItemValue ? `￥${item.accountItemValue}` : ""
      }));
      // 添加应发薪资合计行
      const payAmountTotal = getDisplayValue("应发薪资");
      this.payAmountGrid = [
        { name: "应发薪资合计", value: payAmountTotal ? `￥${payAmountTotal}` : "" },
        ...preTaxAddGridItems
      ];
      
      // 应扣薪资：salaryType=税前减项 + 个税金额 + 对应的累计显示项
      const preTaxDeductionItems = this.items.filter(item => item.salaryType === "税前减项");
      // 获取个税金额（虽然salaryType是税后减项，但需要包含在应扣薪资中）
      const taxItem = this.items.find(item => item.itemName === "个税金额");
      // 获取累计项
      const accumulatedItems = this.items.filter(item => {
        const name = item.itemName || '';
        return name.startsWith("累计") && (
          name.includes("养老") || name.includes("医疗") || 
          name.includes("失业") || name.includes("住房公积金") || 
          name.includes("个税") || name.includes("应税") || name.includes("应发")
        );
      });
      const allDeductionItems = [...preTaxDeductionItems, ...(taxItem ? [taxItem] : []), ...accumulatedItems];
      const deductionGridItems = allDeductionItems.map(item => ({
        name: item.itemName || "",
        value: item.accountItemValue ? (item.salaryType === "税前减项" || item.itemName === "个税金额" ? `-${item.accountItemValue}` : item.accountItemValue) : "",
        negative: item.salaryType === "税前减项" || item.itemName === "个税金额"
      }));
      // 添加应扣薪资合计行
      const deductionTotal = getDisplayValue("应扣薪资");
      this.deductionGrid = [
        { name: "应扣薪资合计", value: deductionTotal ? `-${deductionTotal}` : "", negative: true },
        ...deductionGridItems
      ];
      
      // 抵扣项：salaryType=抵扣项并且展示对应抵扣项的累计显示项
      const deductionItems = this.items.filter(item => item.salaryType === "抵扣项");
      const accumulatedDeductionItems = this.items.filter(item => {
        const name = item.itemName || '';
        return name.startsWith("累计") && (
          name.includes("子女教育") || name.includes("继续教育") || 
          name.includes("住房贷款") || name.includes("住房租金") || 
          name.includes("赡养老人") || name.includes("婴幼儿照护")
        );
      });
      const allDeductionGridItems = [...deductionItems, ...accumulatedDeductionItems];
      this.deductionGridItems = allDeductionGridItems.map(item => ({
        name: item.itemName || "",
        value: item.accountItemValue ? `￥${item.accountItemValue}` : ""
      }));
      
      // 税后减项：salaryType=税后减项且不等于null，且不包含个税金额
      const afterTaxDeductionItems = this.items.filter(item => 
        item.salaryType === "税后减项" && 
        item.accountItemValue !== null && item.accountItemValue !== undefined && item.accountItemValue !== "" &&
        item.itemName !== "个税金额"
      );
      this.afterTaxDeductionGrid = afterTaxDeductionItems.map(item => ({
        name: item.itemName || "",
        value: item.accountItemValue ? `￥${item.accountItemValue}` : ""
      }));
      
      // 税后加项：salaryType=税后加项且不等于null
      const afterTaxAddItems = this.items.filter(item => 
        item.salaryType === "税后加项" && 
        item.accountItemValue !== null && item.accountItemValue !== undefined && item.accountItemValue !== ""
      );
      this.afterTaxAddGrid = afterTaxAddItems.map(item => ({
        name: item.itemName || "",
        value: item.accountItemValue ? `￥${item.accountItemValue}` : ""
      }));
      
      // 设置实发薪资
      const netPayValue = getDisplayValue("实发薪资");
      this.netPayValue = netPayValue ? `￥${netPayValue}` : "";
    },
    sort(type) {
      this.items.sort(this.compare(type));
    },
    compare(attr) {
      return function(a, b) {
        var val1 = a[attr];
        var val2 = b[attr];
        return val1 - val2;
      };
    }
  },
  created() {},
  mounted() {
    this.GetData();
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 24px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.back-btn-box {
  margin-bottom: 20px;
}

.info-card {
  background: white;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  // gap: 16px;
}

.info-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.info-row-second {
  display: flex;
  gap: 280px;
}

.info-row-third {
  display: flex;
}

.avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #DBEAFE;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  flex-shrink: 0;
}

.avatar-text {
  font-size: 22px;
  color: #2576F1;
  font-weight: bold;
}

.info-text {
  display: flex;
  flex-direction: column;
}

.employee-name {
  font-size: 18px;
  font-weight: bold;
  color: #2576F1;
  margin-bottom: 4px;
}

.info-detail {
  font-size: 13px;
  color: #4B5563;
}

.info-item {
  display: flex;
  align-items: center;
  font-size: 13px;
}

.info-item .label {
  color:#4B5563;
}

.info-item .value {
  color: #303133;
}

.section-card {
  background: white;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
}

.section-header {
  display: flex;
  align-items: center;
  // margin-bottom: 16px;
}

.section-icon {
  font-size: 16px;
  margin-right: 8px;
  font-weight: bold;
  
  &.blue { color: #409EFF; }
  &.red { color: #f56c6c; }
  &.orange { color: #f26828; }
  &.purple { color: #9b59b6; }
  &.green { color: #67c23a; }
}

.section-title {
  font-size: 14px;
  font-weight: bold;
  color: #303133;
}

.attendance-card {
  background: white;
}

.attendance-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.attendance-left {
  display: flex;
  gap: 32px;
}

.attendance-row {
  display: flex;
  flex-direction: column;
}

.attendance-row .label {
  font-size: 13px;
  color: #909399;
  margin-bottom: 4px;
}

.attendance-row .value {
  font-size: 16px;
  color: #303133;
  font-weight: 500;
}

.attendance-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.attendance-right .label {
  font-size: 13px;
  color: #909399;
  margin-bottom: 4px;
}

.attendance-right .amount {
  font-size: 30px;
  color: #f26828;
  font-weight: bold;
}

.salary-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 8px;
}

.half-grid {
  grid-template-columns: repeat(2, 1fr);
}

.grid-item {
  background: #fafafa;
  border-radius: 4px;
  padding: 12px 8px;
  text-align: center;
  
  &.total:first-child {
    background: #fef0f0;
  }
}

.item-name {
  font-size: 12px;
  color: #909399;
  margin-bottom: 4px;
}

.item-value {
  font-size: 13px;
  color: #303133;
  
  &.negative {
    color: #f56c6c;
  }
}

.bottom-section {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.half-card {
  margin-bottom: 0;
}

@media screen and (max-width: 1200px) {
  .salary-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media screen and (max-width: 768px) {
  .info-card {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .salary-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .bottom-section {
    grid-template-columns: 1fr;
  }
}
</style>